import { parse } from "valibot"
import clampNumber from "../../../../lib/ldsh/clampNumber"
import { CameraFovSchema, PERSPECTIVE_CAMERA_FOV_MAX, PERSPECTIVE_CAMERA_FOV_MIN } from "./CameraFov"
import { getDeviceUserPreference, setDeviceUserPreference } from "./deviceUserPreferencesSignal"

export function updateCameraFov(newValue : number): void {
  newValue = clampNumber(newValue,
    PERSPECTIVE_CAMERA_FOV_MIN,
    PERSPECTIVE_CAMERA_FOV_MAX)

  console.log('updateFov', getDeviceUserPreference().camera_fov, '->', newValue)

  const parsedNewValue = parse(CameraFovSchema, newValue)

  setDeviceUserPreference({
    ...getDeviceUserPreference(),
    camera_fov: parsedNewValue,
  })
}
